import { clone, IToolsState } from '../../helpers/';
import { DEFAULT_JOURNEY_ID } from '../../constants';
import types from '../types';

const initialState: IToolsState = {
	journeyTitle: 'New Journey',
	journeyId: DEFAULT_JOURNEY_ID,
	saving: false,
	isSharedJourney: false,
	isTriageJourney: false,
	hideSteps: false,
	replaceGuids: false,
	isSaveAndResume: false,
	portalAuthenticationLevel: 586430001,
	portaltimeforcompletion: "{Key:'586430001', Value:'5-10 Minutes'}",
	experimentalFeaturesEnabled: false,
	features: ['print_mode', 'journey_settings'],
	Properties: [],
	isPageJourney: false
};

const toolsReducer = function (state: IToolsState = initialState, action) {
	let stateClone: IToolsState = clone(state);

	switch (action.type) {

		case types.UPDATE_JOURNEY_TITLE:
			updateJourneyTitle(stateClone, action.journeyTitle);
			break;

		case types.UPDATE_JOURNEY_ID:
			updateJourneyId(stateClone, action.journeyId);
			break;

		case types.UPDATE_IS_SHARED_JOURNEY:
			updateIsSharedJourney(stateClone, action.isSharedJourney);
			break;

		case types.UPDATE_IS_PAGE_JOURNEY:
			updateIsPageJourney(stateClone, action.isPageJourney);
			break;

		case types.UPDATE_HIDE_STEPS:
			updateHideSteps(stateClone, action.hideSteps);
			break;

		case types.UPDATE_REPLACE_GUIDS:
			setReplaceGuids(stateClone, action.replaceGuids);
			break;

		case types.UPDATE_SAVE_AND_RESUME:
			setSaveAndResume(stateClone, action.saveAndResume);
			break;

		case types.UPDATE_IS_TRIAGE_JOURNEY:
			updateIsTriageJourney(stateClone, action.isTriageJourney);
			break;

		case types.SET_TOOLS_STATE:
			setToolsState(stateClone, action.toolsState);
			break;

		case types.SET_TOOLS_SAVING:
			setToolsSaving(stateClone, action.saving);
			break;

		case "ENABLE_FEATURE":
			enableFeature(stateClone, action.feature, action.enabled);
			break;

		case types.ENABLE_EXPERIMENTAL_FEATURES:
			let experimental_features = ['default_global_outputs'];
			experimental_features.forEach((feature) => {
				enableFeature(stateClone, feature, action.enabled)
			});
			stateClone.experimentalFeaturesEnabled = action.enabled;
			break;

		case types.SET_JOURNEY_PROPERTIES:
			stateClone.Properties = [].concat(action.properties);
			break;

		case types.UPDATE_JOURNEY_PROPERTY:
			let prop = stateClone.Properties.filter(p => p.Name == action.name)[0];
			if (prop) {
				prop.Value = action.value;
			}
			break;

	}

	return stateClone;
};

let updateJourneyId = (state: IToolsState, journeyId: string): IToolsState => {
	state.journeyId = journeyId;
	return state;
};

let updateJourneyTitle = (state: IToolsState, journeyTitle: string): IToolsState => {
	state.journeyTitle = journeyTitle;
	return state;
};

let updateIsSharedJourney = (state: IToolsState, isSharedJourney: boolean): IToolsState => {
	state.isSharedJourney = isSharedJourney;
	return state;
};

let updateIsPageJourney = (state: IToolsState, isPageJourney: boolean): IToolsState => {
	state.isPageJourney = isPageJourney;
	return state;
};

let updateHideSteps = (state: IToolsState, hideSteps: boolean): IToolsState => {
	state.hideSteps = hideSteps;
	return state;
};

let setReplaceGuids = (state: IToolsState, replaceGuids: boolean): IToolsState => {
	state.replaceGuids = replaceGuids;
	return state;
};

let setSaveAndResume = (state: IToolsState, saveAndResume: boolean): IToolsState => {
	state.isSaveAndResume = saveAndResume;
	return state;
};

let updateIsTriageJourney = (state: IToolsState, isTriageJourney: boolean): IToolsState => {
	state.isTriageJourney = isTriageJourney;
	return state;
};

let setToolsState = (state: IToolsState, toolsState: IToolsState): IToolsState => {
	state.journeyId = toolsState.journeyId;
	state.journeyTitle = toolsState.journeyTitle;
	state.isSharedJourney = toolsState.isSharedJourney;
	state.isTriageJourney = toolsState.isTriageJourney;
	state.isPageJourney = toolsState.isPageJourney;
	state.hideSteps = toolsState.hideSteps;
	state.replaceGuids = toolsState.replaceGuids;
	state.isSaveAndResume = toolsState.isSaveAndResume;
	state.portalAuthenticationLevel = toolsState.portalAuthenticationLevel;
	state.portaltimeforcompletion = toolsState.portaltimeforcompletion;
	return state;
};

const setToolsSaving = (state: IToolsState, saving: boolean): IToolsState => {

	state.saving = saving;
	return state;

};

const enableFeature = (state: IToolsState, featureName: string, enabled: boolean) => {
	if (enabled) {
		state.features.push(featureName);
	}
	else {
		state.features = state.features.filter(x => x !== featureName);
	}

	return state;
}

export default toolsReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/tools.ts